<div class="card-space">
  @if (isLoading || !service) {
    <div class="card-food skeleton-card d-flex align-items-center">
      <div class="circle-food d-flex justify-content-center align-items-center">
        <div
          class="skeleton skeleton-circle"></div>
      </div>
      <div class="flex-grow-1 sub-card">
        <div class="card-header">
          <div class="d-flex align-items-center justify-content-between">
            <span
              class="skeleton skeleton-line w-50"></span>
            <div class="d-flex align-items-center gap-2">
              <span
                class="skeleton skeleton-line w-25"></span>
              <span
                class="skeleton skeleton-icon"></span>
            </div>
          </div>
        </div>
        <div class="card-content">
          <div class="paragraph-text">
            <span
              class="skeleton skeleton-line w-100"></span>
            <span
              class="skeleton skeleton-line w-75"></span>
          </div>
        </div>
        <div class="card-footer">
          <div class="d-flex align-items-center justify-content-between">
            <div class="price-food">
              <span
                class="skeleton skeleton-line w-50"></span>
            </div>
            <div class="d-flex align-items-center gap-2">
              <span
                class="skeleton skeleton-pill"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  } @else {
    <div (click)="onServiceCardClicked()"
         class="card-food d-flex align-items-center">
      <div class="circle-food d-flex justify-content-center align-items-center">
        <img [src]="formatImage('x', service?.Images[0])"
             alt="{{ service.Title }}"
             class="service-image">
      </div>
      <div class="flex-grow-1 sub-card">
        <div class="card-header">
          <div class="d-flex align-items-center justify-content-between">
            <span class="title-food">{{ service.Title }}</span>
            <div class="d-flex align-items-center">
              <div class="d-flex align-items-center me-2">
                <span class="rate-text">{{ service.Rate || 0 | number:'1.1-1' }}</span>
                <img class="me-1 star-icon"
                     src="/icons/star.svg">
              </div>
              <img (click)="onAddToFavoriteClicked($event)"
                   [src]="service.IsFavorite ?  '/icons/heart-solid.svg' : '/icons/heart-stroke.svg'"
                   class="cursor-pointer me-2 favorite-icon">
            </div>
          </div>
        </div>
        <div class="card-content">
          <div class="paragraph-text">
            <p [innerHTML]="domSanitizer.bypassSecurityTrustHtml(service.Description ?? '')"></p>
          </div>
        </div>
        <div class="card-footer">
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center price-food">
              @if (hasMandatoryServicePriceAdditives(service)) {
                <span class="currency">از</span>
                <p class="me-2 price">{{ StringUtil.numberAsCurrency(getCheapestServicePriceAdditives(service)) }}</p>
                <span class="currency">ریال</span>
              } @else {
                @if (service.ServicePrices[0]?.NewPrice !== service.ServicePrices[0]?.Price) {
                  @if (service.ServicePrices[0].NewPrice) {
                    <p class="old-price"
                       style="text-decoration: line-through 2px #E761A8">{{ StringUtil.numberAsCurrency(service.ServicePrices[0]?.Price) }}
                    </p>
                    <span class="currency">ریال</span>
                    <p class="me-2 new-price">{{ StringUtil.numberAsCurrency(service.ServicePrices[0]?.NewPrice) }}</p>
                    <span class="currency">ریال</span>
                  } @else {
                    <p class="me-2 price">{{ StringUtil.numberAsCurrency(service.ServicePrices[0]?.Price) }}</p>
                    <span class="currency">ریال</span>
                  }
                } @else {
                  <p class="me-2 price">{{ StringUtil.numberAsCurrency(service.ServicePrices[0]?.Price) }}</p>
                  <span class="currency">ریال</span>
                }
              }
            </div>
            @if (getRemainedCountLabel(service, service.ServicePrices[0]?.ServicePriceId) !== '0') {
              @if (service.IsOutOfServiceTime) {
                <span class="out-of-stock">خارج از زمان سرویس دهی</span>
              } @else {
                @if (getServiceServicePriceCount(service.ServicePrices[0]?.ServicePriceId) === 0) {
                  <div class="d-flex align-items-center justify-content-between gap-2">
                    <img (click)="onProductOrderClicked(1, $event)"
                         class="cursor-pointer add-icon"
                         src="/icons/add-square.svg">
                  </div>
                } @else {
                  <div class="d-flex align-items-center justify-content-between gap-2">
                    <img (click)="onProductOrderClicked(-1, $event)"
                         class="cursor-pointer remove-icon"
                         src="/icons/bag.svg">
                    <span class="count-text">{{ getServiceServicePriceCount(service.ServicePrices[0]?.ServicePriceId) }}</span>
                    <img (click)="onProductOrderClicked(1, $event)"
                         class="cursor-pointer add-icon"
                         src="/icons/add-square.svg">
                  </div>
                }
              }
            } @else {
              <span class="out-of-stock">اتمام موجودی</span>
            }
          </div>
        </div>
      </div>
    </div>
  }
</div>
